/* eslint-disable @next/next/no-img-element */
import React, { useState } from 'react';
import ContainerHome24 from '../../atoms/ContainerHome24';
import WhiteButton from '../../atoms/WhiteButton/WhiteButton';
import Styles from './CarrosEletricosBannerMoveBrasil.css';
import RedButton from '@/components/atoms/RedButton';

function CarrosEletricosBannerMoveBrasil() {
  const [width, setWidth] = useState(typeof window === 'undefined' ? 0 : window.window.innerWidth);

  if (typeof window === 'undefined') {
    console.log('');
  } else {
    window.addEventListener('resize', function () {
      setWidth(window.window.innerWidth);
    });
  }
  return (
    <>
      <section id="banco-auto-25-banner">
        <ContainerHome24>
          <div className="hero-img">
            {typeof window === 'undefined' ? (
              <></>
            ) : (
              <>
                {width <= 413 && (
                  <img
                    src="assets/carros-eletricos/banner-move-brasil/img-280.png"
                    alt="Motorista de aplicativo sorrindo ao lado do carro elétrico recém-conquistado com financiamento de veículos no Santander pelo Programa Move Brasil."
                    className=""
                  />
                )}
                {width > 413 && width <= 599 && (
                  <img
                    src="assets/carros-eletricos/banner-move-brasil/img-280.png"
                    alt="Motorista de aplicativo sorrindo ao lado do carro elétrico recém-conquistado com financiamento de veículos no Santander pelo Programa Move Brasil."
                    className=""
                  />
                )}
                {width > 599 && width <= 799 && (
                  <img
                    src="assets/carros-eletricos/banner-move-brasil/img-240.png"
                    alt="Motorista de aplicativo sorrindo ao lado do carro elétrico recém-conquistado com financiamento de veículos no Santander pelo Programa Move Brasil."
                    className=""
                  />
                )}
                {width > 799 && width <= 992 && (
                  <img
                    src="assets/carros-eletricos/banner-move-brasil/img-379.png"
                    alt="Motorista de aplicativo sorrindo ao lado do carro elétrico recém-conquistado com financiamento de veículos no Santander pelo Programa Move Brasil."
                    className=""
                  />
                )}
                {width > 992 && (
                  <img
                    src="assets/carros-eletricos/banner-move-brasil/img-572.png"
                    alt="Motorista de aplicativo sorrindo ao lado do carro elétrico recém-conquistado com financiamento de veículos no Santander pelo Programa Move Brasil."
                    className=""
                  />
                )}
              </>
            )}
          </div>
          <div className="hero-contain">
            {/* <div className="hero-selo">
                <img src="assets/mes-do-ambiente/home/img-selo.svg" alt="" className="" />
              </div> */}
            <div className="hero-texts">
              <h1 className="hero-title">Seu elétrico começa aqui</h1>
              <h2 className="hero-sub-title">
                Financie seu veículo híbrido ou elétrico com condições especiais Santander.
              </h2>
            </div>
            <div className="hero-buttons">
              <WhiteButton
                href="https://www.cliente.santanderfinanciamentos.com.br/originacaocliente/?int_source=SF&int_medium=carros-eletricos:banner&int_campaign=simular#/dados-pessoais"
                id="hero-button-simular-financiamento"
                wide
                target="_blank"
              >
                Simule agora
              </WhiteButton>
            </div>
          </div>
        </ContainerHome24>
        <style jsx>{Styles}</style>
      </section>
    </>
  );
}

export default CarrosEletricosBannerMoveBrasil;
